import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SessionService } from '@unity/services/session.service';
import { TenantHttpHeaderKey } from '@unity/utils/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiTenantInterceptor implements HttpInterceptor {
  private readonly sessionService = inject(SessionService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const agencyId = this.sessionService.$currentAgencyId();
    if (agencyId) {
      request = request.clone({
        headers: request.headers.append(TenantHttpHeaderKey, agencyId.toString()),
      });
    }

    return next.handle(request);
  }
}
